import { Box, Paper } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";

import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { useTableStyles } from "@/pages/heat-report/styles/useTableStyles";
import { useTableData } from "./useTableData";

export const ProductionTable = () => {
	const classes = useTableStyles();
	const {
		state: { productionData },
	} = useHeatReportContext();

	const { columns, defaultColDef } = useTableData();

	return (
		<>
			<Paper className={classes.borderAgGridTable} elevation={0}>
				<Box p={0}>
					<div style={{ height: "13rem" }}>
						<AgGridReact
							rowData={productionData}
							columnDefs={columns}
							domLayout="normal"
							suppressRowClickSelection={true}
							suppressPaginationPanel={true}
							getRowId={(params) => params.data.ProductBatchId}
						/>
					</div>
				</Box>
			</Paper>
		</>
	);
};
